import { isEmpty } from "lodash";

export const updateSettings = (array,updateSettingRes) => {
    if(!isEmpty(array)){
        if(!isEmpty(array[0])){
            array[0].settings = updateSettingRes
        }
    }
    return array
}